import React from 'react';
import MaterialTable from 'material-table'
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { Route, Link, BrowserRouter, Redirect, Switch as Router } from 'react-router-dom';
import {withRouter, generatePath} from 'react-router-dom'

const axios = require('axios');
const path = require('path');

class ProjectTable extends React.Component {
    constructor(props){
      super(props);
  
      this.state = {
        name: '',
        data: [],
        users: [],
        url: props.url,
        loadingMainsails: true,
        loadingHeadsails: true,
        loadingAsyms: false,   
        uRl: "",
        redirect: false,  
      }; 
      
    } 

    componentDidMount(){
      this.readSails(this.props.url);
    }

    updateTable = (uRl) => {
      let data = this.readSails(uRl);
      return data;
    }

    fetchURLfile = (uRl, callback) =>{
      const PROXY_URL = 'https://cors-anywhere.herokuapp.com/';
      const myURL = (uRl);
      const newURL = myURL.replace('dl=0', "raw=1")
      axios.get(PROXY_URL + newURL)
      .then(response=> {
         callback(response.data);
      })
      .catch(function (error) {
        let data = false;
        callback(data);
        alert(error);
      })
      .finally(function () {

      });
    }

    readSails = (uRl) =>{

      const self = this;
      
      this.fetchURLfile(uRl,(value) =>{  
    
      let results = [];
      let index = 0;

      if(value){
        self.setState({name:value.ProjectName, users:value.Users});
        if(value.Mainsails.length > 0){
          self.setState({loadingMainsails: true})
        }else{
          self.setState({loadingMainsails: false})
        }
        if(value.Headsails.length > 0){
          self.setState({loadingHeadsails: true})
        }else{
          self.setState({loadingHeadsails: false})
        }
        {value.Mainsails.map((sailPath,index) => {
          
          this.fetchURLfile(sailPath, (val) => { 

          let p50 = val.curves.find(e => e.name == "50%"); 

          let tws = val.LogData.find(e => e.name.includes("TWS"));
          
          let parentId = "m" + index;
          
          let MainsailData1 = {
              id: "m" + index,
              backColor: "rgb(136, 174, 255)",
              sailPath: sailPath,
              sail: "Mainsail",
              code: val.sail,         
              date: val.imageTime,
              tws: tws ? tws.value.toFixed(0) : "",
              pos: p50 ? p50.name : "",
              draft: p50 ? p50.draft.toFixed(1) : "",
              camber: p50 ? p50.camber.toFixed(3) : "",
              twist: p50 ? p50.twist.toFixed(1) : "",
              entry: p50 ? p50.EntryAngle.toFixed(0) : "",
              exit:  p50 ? p50.ExitAngle.toFixed(0) : "",
              front: p50 ? p50.frontPercent.toFixed(1) : "",
              back: p50 ? p50.backPercent.toFixed(1) : "",
          }

          results.push(MainsailData1);
          val.curves.sort((a, b) => (a.name > b.name) ? 1 : -1)
          {val.curves.map((curve,i) => {
              let MainsailData2 = {
                id: "m" + index.toString() + i.toString(),
                backColor: "#EEE",
                parentId: parentId,
                pos: curve.name,
                draft: curve.draft.toFixed(1),
                camber: curve.camber.toFixed(3),
                twist: curve.twist.toFixed(1),
                entry: curve.EntryAngle.toFixed(0),
                exit:  curve.ExitAngle.toFixed(0),
                front: curve.frontPercent ? curve.frontPercent.toFixed(1) : " ",
                back: curve.backPercent ? curve.backPercent.toFixed(1) : " ",
              } 
              results.push(MainsailData2);         
          })}
            this.setState({data:results});
          })
          value.Mainsails[index+1] ? self.setState({loadingMainsails: true}) :  self.setState({loadingMainsails: false});
        }); 
      }

        {value.Headsails.map((sailPath,index) => {

          this.fetchURLfile(sailPath, (val) => {   

          let p50 = val.curves.find(e => e.name == "50%"); 

          let tws = val.LogData.find(e => e.name.includes("TWS"));
          
          let parentId = "h" + index;
          
          let HeadsailData1 = {
              id: "h" + index,
              backColor: "rgb(214, 255, 214)",
              sailPath: sailPath,
              sail: "Headsail",
              code: val.sail,         
              date: val.imageTime,
              tws: tws ? tws.value.toFixed(0) : "",
              pos: p50 ? p50.name : "",
              draft: p50 ? p50.draft.toFixed(1) : "",
              camber: p50 ? p50.camber.toFixed(3) : "",
              twist: p50 ? p50.twist.toFixed(1) : "",
              entry: p50 ? p50.EntryAngle.toFixed(0) : "",
              exit:  p50 ? p50.ExitAngle.toFixed(0) : "",
              front: p50 ? p50.frontPercent.toFixed(1) : "",
              back: p50 ? p50.backPercent.toFixed(1) : "",
          }

          results.push(HeadsailData1);
          val.curves.sort((a, b) => (a.name > b.name) ? 1 : -1)
          {val.curves.map((curve,i) => {
              let HeadsailData2 = {
                id: "h" + index.toString() + i.toString(),
                backColor: "#EEE",
                parentId: parentId,
                pos: curve.name,
                draft: curve.draft.toFixed(1),
                camber: curve.camber.toFixed(3),
                twist: curve.twist.toFixed(1),
                entry: curve.EntryAngle.toFixed(0),
                exit:  curve.ExitAngle.toFixed(0),
                front: curve.frontPercent ? curve.frontPercent.toFixed(1) : " ",
                back: curve.backPercent ? curve.backPercent.toFixed(1) : " ",
              } 
              results.push(HeadsailData2);         
          })}
          this.setState({data:results});
        })  
        value.Headsails[index+1] ?  self.setState({loadingHeadsails: true}) :  self.setState({loadingHeadsails: false});
        }); 
      }
    }

    });

    }

    openSail = (id) => {
      let d = this.state.data.find(e => e.id == id);
      const newURL = d.sailPath.replace('https://www.dropbox.com', "")
      let newPath ="/TrueNorthSailAnalysis/Sail?x=" + newURL;
      this.setState({uRl: newPath, redirect: true});
      //let path = d.sailPath;
      //this.props.app.openSailPath(path);
    }

    render() {

        const {data, loadingMainsails, loadingHeadsails, name, redirect, uRl} = this.state;
        const projectName = this.props.app.state.projectName;

        if (redirect) {
          return <Redirect push to={uRl} />;
        }

        let page;
        if(loadingMainsails && data || loadingHeadsails){
           page=(
            <CircularProgress disableShrink style={{width:"100px", height:"100px"}}/>
           );
        }else{
          page=(
            <MaterialTable
            style={{maxWidth:"97%", padding:"0px 15px", boxShadow:'rgba(0, 0, 0, 0.2) 0px 8px 12px 0px, rgba(0, 0, 0, 0.2) 0px 6px 12px 0px'}}
            title={name}
            columns={[
              { title: 'ID', field: 'id', hidden:true },
              { title: 'Color', field: 'backColor', hidden:true },
              { title: 'Sail', field: 'sail', cellStyle: { fontSize: "0.8rem"} },
              { title: 'Code', field: 'code' , cellStyle: { fontSize: "0.8rem"} },
              { title: 'DateTime', field: 'date' , cellStyle: { fontSize: "0.75rem"} },
              { title: 'TWS', field: 'tws' , type: 'numeric' , editable: "always", cellStyle: { fontSize: "0.8rem"} },
              { title: 'Position', field: 'pos' , type: 'numeric', cellStyle: { fontSize: "0.8rem"}},
              { title: 'Draft', field: 'draft' , type: 'numeric', cellStyle: { fontSize: "0.8rem"}},
              { title: 'Camber', field: 'camber' , type: 'numeric', cellStyle: { fontSize: "0.8rem"}},
              { title: 'Twist', field: 'twist' , type: 'numeric', cellStyle: { fontSize: "0.8rem"}},
              { title: 'Entry', field: 'entry' , type: 'numeric', cellStyle: { fontSize: "0.8rem"}},
              { title: 'Exit', field: 'exit' , type: 'numeric', cellStyle: { fontSize: "0.8rem"}},
              { title: 'Front', field: 'front', type: 'numeric' , cellStyle: { fontSize: "0.8rem"}},
              { title: 'Back', field: 'back' , type: 'numeric', cellStyle: { fontSize: "0.8rem"}},
            ]}
            data={data}        
            actions={[
              rowData => ({
                icon: 'search',
                tooltip: 'open sail',
                onClick: (event, rowData) => this.openSail(rowData.id),
                hidden: rowData.parentId
              }),
              rowData => ({
                icon: 'delete',
                tooltip: 'delete sail',
                onClick: (event, rowData) => alert("You want to delete " + rowData.code),
                hidden: rowData.parentId
              }),
              {
                icon: 'refresh',
                tooltip: 'Refresh data',
                isFreeAction: true,
                onClick: (event) => alert("You want to add a new row")
              }
            ]}
            parentChildData={(row, rows) => rows.find(a => a.id === row.parentId)}
            options={{
              rowStyle: rowData => ({
                backgroundColor: (rowData.backColor),
              }),
              pageSize: 10,
              pageSizeOptions:[5,10],
              maxBodyHeight: "60vh",
              padding:"dense",
            }}
          />
          );
        }

        return (
          <Grid container style={{margin:"0px", position: "fixed", width: "100%", height: "100%", left: "0px", top: "0px"}} justify={'center'} alignItems={'center'}> 
          {page} 
          </Grid>
          
        )
    }


}
      
export default ProjectTable;


/*
[
              { id: 1, sail: 'Mainsail', code: 'MNAP-5', date: "2019-07-05 12:56:29", tws: 13.9, pos:"50%", draft: 34, camber: 0.114, twist: 14, entry:42, exit:12, front: 0.82, back: 0.64},
              { id: 2, parentId: 1, pos:"25%", draft: 34, camber: 0.114, twist: 14, entry:42, exit:12, front: 0.82, back: 0.64},
              { id: 3, parentId: 1, pos:"50%", draft: 34, camber: 0.114, twist: 14, entry:42, exit:12, front: 0.82, back: 0.64},
              { id: 4, parentId: 1, pos:"75%", draft: 34, camber: 0.114, twist: 14, entry:42, exit:12, front: 0.82, back: 0.64},
              { id: 5, sail: 'Headsail', code: 'J15-5', date: "2019-07-06 12:56:29", tws: 13.9, pos:"50%", draft: 34, camber: 0.114, twist: 14, entry:42, exit:12, front: 0.82, back: 0.64},
            ]


*/